import { colors, fonts } from '@grupoboticario/flora-tokens/dist/casaMagalhaesCereja/web/ds'

export const casaMagalhaesCereja = {
  colors,
  fonts,
}
